export const SEND_POOL_REQUEST_REQUEST = 'SEND_POOL_REQUEST_REQUEST';

export const sendPoolRequestRequest = ( poolRequestData ) => ({
    type: SEND_POOL_REQUEST_REQUEST,
    payload: { poolRequestData },
});
